







MediumEditor = require('medium-editor')
require('medium-editor/dist/css/medium-editor.css')

import blockMixin from './../BlockMixin.vue'

export default {
  name: 'text'

  mixins: [blockMixin]

  data: -> {
    content: ''
    fields: {
      content: ''
    }
  }

  created: ->
    this.content = this.block.fields.content

  mounted: ->
    editor = new MediumEditor(this.$el.querySelector('.bb8-block-text'), {
      spellcheck: false
      disableExtraSpaces: true
      toolbar: {
        allowMultiParagraphSelection: true
        buttons: ['bold', 'italic', 'anchor', 'orderedlist', 'unorderedlist']
      }
      anchor: {
        targetCheckbox: false
      }
    })

    this.$el.querySelector('.bb8-block-text').focus() if this.block.fields.content.length <= 0

    # that = this
    # editor.subscribe('editableInput', (event, editable) ->
    #   that.block.fields.content = event.target.innerHTML
    # )

  methods: {
    updateText: (event) ->
      this.block.fields.content = event.target.innerHTML

    removeBlock: (event) ->
      return if event.target.innerText.replace(/\s+/g,"").length > 0
      this.$emit('remove-block', this.index)
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/blocks/TextBlock.vue